var map = {
	"./news-bg.png": "5767",
	"./news-logo-hover.png": "2b35",
	"./news-logo.png": "2f84",
	"./news1.png": "bf19",
	"./news10.png": "9235",
	"./news2.png": "b391",
	"./news3.png": "d483",
	"./news4.png": "6cc3",
	"./news5.png": "0b96",
	"./news6.png": "8d5d",
	"./news7.png": "cec5",
	"./news8.png": "1be8",
	"./news9.png": "0214",
	"./newsDetail.png": "9f39"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3d81";